import { nullableSchema, NumberSchema, objectSchema, schemaProperties } from "vue-utils"

export type Id = number
export const Id = NumberSchema

export type Nullable<T> = T | null
export const Nullable = nullableSchema

export interface Identifiable {
	id: Id
}
export const Identifiable = objectSchema<Identifiable>({
	id: Id,
})

export interface Named {
	name: string
}
export const Named = objectSchema<Named>({
	name: String,
})

export interface GenericEntity extends Identifiable {}
export const GenericEntity = objectSchema<GenericEntity>({
	id: Id,
})

export const extend = schemaProperties
